
import { Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { FiExternalLink } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { setIsPreFiltered, setPreDefinedFilter } from '../../redux/slices/pricingSlice';
import { useDispatch } from 'react-redux';
import { getPriceChangeBGColor, getPercentile, mergeFilters } from '../../utils/utils';
import amplitude from '../../utils/ampli';


const MIDetailedColorClarity = ({idealTurn, isCsr,
    isColorClarityLoading,
    selectedNeedsMetric,
    newData,
    filtered,
    colorKeys,
    clarityDatas,
    allClarityRanges,
    selectedMetric,
    handleCellClick,
    roundIfFloat,
    roundToOneDecimal,
    getBgColor,
    getCellStyle,
    shape, 
    caratRange,
    hoveredCell,
    handleCellHover,
    selectedCell,
    drilldownRef }) => {


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [allColor, setAllColor] = useState({
        discrete: {
        "diamond#color": [],
    }
    })

    const [allClarity, setAllClarity] = useState({
    discrete: {
    "diamond#clarity": [],

    }})

    const handleColorClick = (value) => {
      const newColorState = {
        discrete: {
          "diamond#shape":shape == "0007cushion_brilliant"?[shape, "0008cushion_modified"]: [shape],
          "gem#carats": [
          {
            "from": caratRange.split('-')[0],
            "to": caratRange.split('-')[1]
          }],
          "diamond#color": [value],
        },
      };
  
      setAllColor(newColorState); // Update state
      const discreteFilters = mergeFilters(filtered,transformFilters(newColorState)); // Use the updated state
      
      dispatch(setIsPreFiltered(true));
      dispatch(setPreDefinedFilter(discreteFilters));
     
      const buttonClickedEvent = {
              event_type: `v3_Detailed_color_header_click_to_pcp`,
                value: value,
            };
      amplitude.track(buttonClickedEvent);
      navigate(`/price_co-pilot?page=0`);
    }; 
    
    const handleClarityClick = (value) => {
        const newClarityState = {
            discrete: {
              "diamond#shape": shape == "0007cushion_brilliant"?[shape, "0008cushion_modified"]: [shape],
              
              "gem#carats": [
              {
                "from": caratRange.split('-')[0],
                "to": caratRange.split('-')[1]
              }],
              "diamond#clarity": [value],
            },
          };
    
        setAllClarity(newClarityState); // Update state
        const discreteFilters = mergeFilters(filtered,transformFilters(newClarityState)); // Use the updated state
        dispatch(setIsPreFiltered(true));
        dispatch(setPreDefinedFilter(discreteFilters));
        const buttonClickedEvent = {
                event_type: `v3_Detailed_clarity_row_click_to_pcp`,
                  value: value,
              };
        amplitude.track(buttonClickedEvent);
        navigate(`/price_co-pilot?page=0`);
    }; 
    
    
    const transformFilters = (filters) => {
      const transformed = {
        item_filter: {
            discrete: {},
            from: {},
            text: {},
            to: {},
        },
      };
  
      // Process discrete filters
      if (filters?.discrete) {
        Object.entries(filters.discrete).forEach(([key, value]) => {
          if (key === "diamond#color" || key === "diamond#clarity" || key === "diamond#shape") {
            // Ensure value is an array and not empty
            transformed.item_filter.discrete[key] = Array.isArray(value) ? value : [value];
          } else if (key === "gem#carats") {
            const carats = value;
            let min = null;
            let max = null;
            
            carats.forEach((carat) => {
              if (carat.from !== undefined) {
                min = min !== null ? Math.min(min, parseFloat(carat.from)) : parseFloat(carat.from);
              }
              if (carat.to !== undefined) {
                max = max !== null ? Math.max(max, parseFloat(carat.to)) : parseFloat(carat.to);
              }
            });
            
            if (min !== null) transformed.item_filter.from["gem#carats"] = min.toString();
            if (max !== null) transformed.item_filter.to["gem#carats"] = max.toString();
          }
        });
      }
        
      // Process rowFilters for carats (assuming it contains gem#carats)
        
      for (const key in transformed.item_filter.discrete) {
        if (Array.isArray(transformed.item_filter.discrete[key])) {
          transformed.item_filter.discrete[key] = [...new Set(transformed.item_filter.discrete[key])];
        }
      }
    
      return transformed;
    }; 

   


  return (
    <div className="w-1/2">
            {/* <h3 className="text-center text-inherit text-2xl font-medium">Detailed</h3> */}
            {/* Detailed View */}
            {/* {!isColorClarityLoading && ( */}
              <table className="grid-shape-size self-center">
                <thead style={{ zIndex: 1 }}>
                  <tr className="bg-gray-200">
                    <th style={{ width: "55px" }} className="border border-gray-300">Col / Clar</th>
                    {colorKeys.length > 0 && 
                    Object.keys(newData?.data[colorKeys[0]] || {})
                    .filter(key => key !== 'trans')
                      .map((clarity) => (
                      <th onClick={() => handleClarityClick(clarity)} key={clarity} style={{cursor: "pointer"}}>
                        {newData?.data[colorKeys[0]][clarity]?.trans || clarity}
                      </th>
                      ))
                  }
                  </tr>
                </thead>
                <tbody>
                  {colorKeys.map((color, rowIndex) => (
                    <tr key={color}>
                      <td style={{ width: "10%", cursor: "pointer" }} onClick={() => handleColorClick(color)}>{newData?.data[color]?.trans}</td>
                      {allClarityRanges.map((clarity, colIndex) => {
                        let cellData = clarityDatas[rowIndex][colIndex][selectedMetric];
                        
                        let colorCode = clarityDatas
                          .flat()
                          .map((cell) => cell[selectedMetric])
                          .filter((v) => v !== undefined && v !== null)
                          .sort((a, b) => a - b);
                          
                        if(selectedMetric === "price_change"){
                          cellData = Math.round(cellData * 10) / 10;
                          colorCode = clarityDatas
                            .flat()
                            .map((cell) => Math.round(cell[selectedMetric] * 10)/10)
                            .filter((v) => v !== undefined && v !== null)
                            .sort((a, b) => a - b);
                        }

                        function getPercentile(arr, percentile) {
                          const index = (percentile / 100) * (arr.length - 1);
                          const lower = Math.floor(index);
                          const upper = Math.ceil(index);
                          if (lower === upper) return arr[lower];
                          return arr[lower] + (arr[upper] - arr[lower]) * (index - lower);
                        }
                        let min = getPercentile(colorCode, 10);  // 10th percentile
                        let max = getPercentile(colorCode, 90);  // 90th percentile  
                        {/* let min = Math.min(...clarityDatas.flat().filter(cell => cell && typeof cell[selectedMetric] === 'number').map(cell => cell[selectedMetric]));
                        let max = Math.max(...clarityDatas.flat().filter(cell => cell && typeof cell[selectedMetric] === 'number').map(cell => cell[selectedMetric])); */}
                        {/* let neutralValue = 0; */}
                        let neutral = getPercentile(colorCode, 50);
                        let displayValue = roundIfFloat(cellData);
                        let reverseColoring = false;
                        let bgColor = getBgColor(min, max, cellData, neutral, 50, reverseColoring);
                        if(selectedMetric === "price_change"){
                          neutral = 0;
                          bgColor = getPriceChangeBGColor(min, max, cellData, neutral, 50, reverseColoring);
                        }
                        if(selectedMetric === "overhang"){
                          reverseColoring = true;
                          bgColor = getBgColor(min, max, cellData, neutral, 50, reverseColoring);
                        }
                        const isHighlighted = hoveredCell && hoveredCell.column === colIndex && hoveredCell.row === rowIndex;
                        if(selectedMetric === "overhang"){
                          if (cellData === null) {
                              displayValue = "-";
                              bgColor = "#fff";
                            }
                            else{
                              displayValue = cellData.toFixed(0);

                            }
                          }
                        if(selectedMetric === "liquidity"){
                            if (cellData === null || cellData === 0) {
                                displayValue = "-";
                                bgColor = "#fff";
                              }
                            else{
                              displayValue = cellData.toFixed(0);

                            }
                        }
                        if(selectedMetric === "sales_distribution" ){
                          if (cellData === null) {
                              displayValue = "-";
                              bgColor = "#fff";
                            }
                          else{
                            displayValue = cellData.toFixed(2) + "%";

                          }
                        }
                        if(selectedMetric === "price_change"){
                          if (cellData === null) {
                              displayValue = "-";
                              bgColor = "#fff";
                            }
                          else{
                            displayValue = cellData.toFixed(1) + "%";

                          }
                        }
                        let outline = isHighlighted ? '1px solid black' : 'none';
                        const tooltipContent = (
                        <>
                          
                          <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                            <div className="w-max">Sales Distribution: </div>
                            <div className="text-left"><strong>{(clarityDatas[rowIndex][colIndex].sales_distribution)?.toFixed(2)}</strong>%</div>
                          </div>
                          <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                            <div className="w-max">Price Change: </div>
                            <div className="text-left"><strong>{(clarityDatas[rowIndex][colIndex].price_change)?.toFixed(1)}</strong>%</div>
                          </div> 

                          {isCsr && (
                          <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                            <div className="w-max">Count: </div>
                          <div className="text-left"><strong>{clarityDatas[rowIndex][colIndex].count}</strong></div>
                            </div>
                          )}
                              
                          <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                            <div className="w-max">Inventory Overhang:  </div>
                            <div className="text-left">
                              <strong>
                                {clarityDatas[rowIndex] &&
                                clarityDatas[rowIndex][colIndex] &&
                                    clarityDatas[rowIndex][colIndex].overhang != null
                                    ? clarityDatas[rowIndex][colIndex].overhang?.toFixed(0)
                                    : "-"}
                              </strong> <span className="text-xs">days</span>
                            </div>
                          </div>
                          {/* <div className="flex justify-between w-max items-center" style={{width: "124px"}}>
                            <div className="w-max">Liquidity:  </div>
                            <div className="text-left"><strong>{clarityDatas[rowIndex][colIndex].liquidity}</strong></div>
                          </div> */}
                        </>
                      );
                      
                     
                      
                     
                      
                      {/* if selectedMetric is "inventory" or "sales" and the value is 0 then show "-" */}
                      {/* if selectedMetric is "turn" and the inventory and sales values are 0 then show "-" */}
                        return (
                          <Tooltip key={`${clarity}-${color}`} title={tooltipContent} arrow placement="right-start" disableInteractive> 
                          <td
                            key={clarity}
                            className={cellData === 0 ? (selectedMetric === "needs" ? "cursor-pointer" : "cursor-not-allowed") : "cursor-pointer"}
                            // style={getCellStyle(bgColor, color, clarity, clarityDatas[rowIndex][colIndex], outline)}
                            style={{
                            height: "52.3px",
                            minWidth: "48.4px",
                            color: "#000",
                            border: selectedCell?.color === color && selectedCell?.clarity === clarity ? "2px solid #000" : "1px solid #ccc",
                            padding: "0",
                            margin: "0 auto",
                            maxWidth: "55px",
                            backgroundColor: bgColor,
                            outline: isHighlighted ? "1px solid black " : "none",
                            outlineOffset: "-1px",
                            boxShadow: "none",
                            fontWeight: "normal",
                          }}
                            onClick={() =>
                              handleCellClick(
                                color,
                                clarity,
                                clarityDatas[rowIndex][colIndex]
                              )
                            }
                          onMouseEnter={() => handleCellHover(colIndex, rowIndex)}
                          onMouseLeave={() => handleCellHover(null, null)}
                          >
                          {  
                                  (<span>{displayValue}</span>)  
                            
                          }
                          </td>
                          </Tooltip> 
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table> 
          </div>
  )
}

export default MIDetailedColorClarity